export const platinumCreditCard = [
  {
    title: 'Structured under the Tawarruq concept',
    description:
      'This card offers you credit convenience while remaining in full compliance with Shariah principles.'
  },
  {
    title: 'Zero annual fee',
    description: 'Annual fee is waived for life on both principal and supplementary cards.'
  },
  {
    title: 'Enjoy 5% cashback',
    description:
      'On dining, groceries, online transactions, and utility payments, capped at RM30 per month.'
  },
  {
    title: 'Unlimited 0.2% cashback',
    description: 'On all other eligible retail purchases.'
  }
]

export const signatureCreditCard = [
  {
    title: 'Structured under the Tawarruq concept',
    description:
      'This card offers you premium credit convenience while remaining in full compliance with Shariah principles.'
  },
  {
    title: 'Earn up to 10% cashback',
    description: 'On all overseas spend (capped at RM80 per month).'
  },
  {
    title: 'Enjoy unlimited 0.6% cashback',
    description: 'On other eligible local spend.'
  },
  {
    title: 'Access 24/7 Visa concierge service',
    description: 'For travel, dining, and lifestyle assistance anytime.'
  },
  {
    title: 'Complimentary airport lounge access',
    description: 'Enjoy 2X complimentary access to Priority Pass airport lounge annually.'
  },
  {
    title: 'Annual fee waiver',
    description:
      'Annual fee waived for the first year and subsequently waived with a minimum of one transaction per month for 12 consecutive months.'
  }
]
